import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Link } from 'react-router-dom';
import { Dropdown } from 'Common/Components/Dropdown';
import TableContainer from 'Common/TableContainer';
import moment from "moment";
import Select from 'react-select';

// Icons
import { Search, Trash2, Plus, MoreHorizontal, FileEdit } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

// Images

// react-redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  onGetServiceCustomFormList,
  onUpdateServiceCustomForm,
  onAddServiceCustomForm,
  onDeleteServiceCustomForm,
} from 'slices/thunk';
import { ToastContainer } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';
import { doListServices } from '../../services/booking.service';

import deleteImg from "assets/images/delete.png";
import addImg from "assets/images/add.png";

const CustomForm = () => {
  const dispatch = useDispatch<any>();

  const selectDataList = createSelector(
    (state: any) => state.Booking,
    (booking) => ({
      customFormList: booking.customFormList
    })
  );

  const { customFormList } = useSelector(selectDataList);
  const [customForm, setCustomForm] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();

  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [serviceDroplist, setServiceDroplist] = useState<Array<{ value: string, label: string }>>([])

  // Get Data
  useEffect(() => {
    dispatch(onGetServiceCustomFormList())
  }, [dispatch]);

  useEffect(() => {
    setCustomForm(customFormList)
  }, [customFormList]);

  useEffect(() => {
    handleGetService()
  }, [])

  const handleGetService = () => {
    doListServices(0).then((resp: any) => {
      const data = resp.map((item: any) => {
        return {
          value: item.serviceId,
          label: item.title
        }
      });
      setServiceDroplist(data);
    })
  }

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.serviceCustomFormId) {
      setEventData(cell);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteServiceCustomForm(eventData.serviceCustomFormId));
      setDeleteModal(false);
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      serviceCustomFormId: (eventData && eventData.serviceCustomFormId) || '',
      serviceIds: (eventData && eventData.serviceIds) || [],
      type: (eventData && eventData.type) || '',
      key: (eventData && eventData.key) || '',
      label: (eventData && eventData.label) || '',
      choices: (eventData && eventData.choices) || [],
      required: (eventData && eventData.required) || false,
      applyToAll: (eventData && eventData.applyToAll) || false,
      sequence: (eventData && eventData.sequence) || 0,
      instruction: (eventData && eventData.instruction) || '',
    },
    validationSchema: Yup.object({
      serviceCustomFormId: Yup.string().optional().nullable(),
      serviceIds: Yup.array().of(Yup.string().optional().nullable()),
      type: Yup.string().required("Service Type is required"),
      key: Yup.string().required("Key is required"),
      label: Yup.string().required("Label is required"),
      choices: Yup.array().of(Yup.string()).optional().nullable(),
      required: Yup.boolean().default(false),
      applyToAll: Yup.boolean().default(false),
      sequence: Yup.number().default(0),
      instruction: Yup.string().optional().nullable(),
    }),

    onSubmit: (values) => {
      const data = {
        ...values,
      };
      if (isEdit) {
        dispatch(onUpdateServiceCustomForm(data));
      } else {
        delete data.serviceCustomFormId;
        dispatch(onAddServiceCustomForm(data));
      }
      toggle();
    },
  });

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      // setSelectedImage('');
    } else {
      setShow(true);
      setEventData("");
      // setSelectedImage('');
      validation.resetForm();
    }
  }, [show, validation]);

  const typeSelect = [
    { value: 'input', label: 'Input' },
    { value: 'choices', label: 'Choices' },
    { value: 'number', label: 'Number' },
    { value: 'date', label: 'Date' },
  ];

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ['key', 'label'];
    filterDataBySearch(customFormList, search, keysToSearch, setCustomForm);
  };

  const columns = useMemo(() => [
    {
      header: (
        <div className="flex items-center h-full">
          <input id="CheckboxAll" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
        </div>
      ),
      enableSorting: false,
      id: "checkAll",
      cell: (cell: any) => {
        return (
          <div className="flex items-center h-full">
            <input id="Checkbox1" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
          </div>
        );
      }
    },
    {
      header: "Key",
      accessorKey: "key",
      enableColumnFilter: false
    },
    {
      header: "Label",
      accessorKey: "label",
      enableColumnFilter: false
    },
    {
      header: "Required",
      accessorKey: "required",
      enableColumnFilter: false
    },
    {
      header: "Sequence",
      accessorKey: "sequence",
      enableColumnFilter: false
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <span>{moment(cell.getValue()).format("DD MMM YYYY")}</span>
      ),
    },
    {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <Dropdown className="relative">
          <Dropdown.Trigger className="flex items-center justify-center w-[30px] h-[30px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20" id={cell.row.original.serviceId}>
            <MoreHorizontal className="w-3 h-3" />
          </Dropdown.Trigger>
          <Dropdown.Content placement="right-end" className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md min-w-[10rem] dark:bg-zink-600" aria-labelledby={cell.row.original.serviceId}>
            <li>
              <Link data-modal-target="addUserModal" className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!"
                onClick={() => {
                  const data = cell.row.original;
                  handleUpdateDataClick(data);
                }}>
                <FileEdit className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Edit</span></Link>
            </li>
            <li>
              <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!" onClick={() => {
                const orderData = cell.row.original;
                onClickDelete(orderData);
              }}><Trash2 className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Delete</span></Link>
            </li>
          </Dropdown.Content>
        </Dropdown>
      ),
    }
  ], []
  );

  return (
    <React.Fragment>
      <BreadCrumb title='Services' pageTitle='Service Custom Form' />
      <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="usersTable">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Service Custom Form List</h6>
                <div className="shrink-0">
                  <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}><Plus className="inline-block w-4 h-4" />
                    <span className="align-middle">Add Custom Form</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-2">
                    <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for name, email, phone number etc..." autoComplete="off" onChange={(e) => filterSearchData(e)} />
                    <Search className="inline-block w-4 h-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              {customForm && customForm.length > 0 ?
                <TableContainer
                  isPagination={true}
                  columns={(columns || [])}
                  data={(customForm || [])}
                  customPageSize={10}
                  divclassName="-mx-5 -mb-5 overflow-x-auto"
                  tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                  theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                  thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                  tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                  PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                />
                :
                (<div className="noresult">
                  <div className="py-6 text-center">
                    <Search className="w-6 h-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 199+ data We did not find any data for your search.</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
          <Modal.Title className="text-16">{!!isEdit ? "Edit Form" : "Add Form"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form action="#!" onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
            <div className="mb-3">
              <label htmlFor="keyInput" className="inline-block mb-2 text-base font-medium">Key</label>
              <input
                type="text"
                id="keyInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Key"
                name="key"
                onChange={validation.handleChange}
                value={validation.values.key || ""}
              />
              {validation.touched.key && validation.errors.key ? (
                <p className="text-red-400">{validation.errors.key}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="labelInput" className="inline-block mb-2 text-base font-medium">Label</label>
              <input
                type="text"
                id="labelInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Label"
                name="label"
                onChange={validation.handleChange}
                value={validation.values.label || ""}
              />
              {validation.touched.label && validation.errors.label ? (
                <p className="text-red-400">{validation.errors.label}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="priceInput" className="inline-block mb-2 text-base font-medium">Sequence</label>
              <input
                type="number"
                id="priceInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Sequence"
                name="sequence"
                onChange={validation.handleChange}
                value={validation.values.sequence || 0}
              />
              {validation.touched.sequence && validation.errors.sequence ? (
                <p className="text-red-400">{validation.errors.sequence}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="typeInput" className="inline-block mb-2 text-base font-medium">Type</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={typeSelect}
                isSearchable={false}
                name="type"
                id="typeInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`type`, selectedOption?.value)
                }}
                value={typeSelect.find(type => { return type.value === validation.values.type })}
              />
              {validation.touched.type && validation.errors.type ? (
                <p className="text-red-400">{validation.errors.type}</p>
              ) : null}
            </div>
            {validation.values.type === 'choices' &&
              <div className="mb-3">
                <label htmlFor="choicesInput" className="inline-block mb-2 text-base font-medium">Choices</label>
                <button type="button" className="btn btn-primary" onClick={() => {
                  const newChoices = [...validation.values.choices, ''];
                  validation.setFieldValue(`choices`, newChoices);
                }}><img src={addImg} alt="" className="block h-5 mx-auto" /></button>
                {
                  validation.values.choices.map((choice: any, index: number) => {
                    return (
                      <Fragment>
                        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                          <div className="xl:col-span-10">
                            <input type="text"
                              id={`choicesInput.${index}`}
                              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 mt-2"
                              placeholder="Enter Choices"
                              name={`choices.${index}`}
                              onChange={validation.handleChange}
                              value={validation.values.choices?.[index] || ""}
                            />
                          </div>
                          {index > 0 &&
                            <div className="xl:col-span-2">
                              <button type="button" className="btn btn-danger" onClick={() => {
                                const newChoices = [...validation.values.choices];
                                newChoices.splice(index, 1);
                                validation.setFieldValue('choices', newChoices);
                              }}><img src={deleteImg} alt="" className="block h-5 mx-auto" /></button>
                            </div>
                          }
                        </div>
                      </Fragment>
                    )
                  })
                }
                {validation.touched.description && validation.errors.description ? (
                  <p className="text-red-400">{validation.errors.description}</p>
                ) : null}
              </div>
            }
            <div className="mb-3 flex">
              <label htmlFor="requiredInput" className="inline-block mb-2 text-base font-medium">Required?</label>
              <input
                type="checkbox"
                id="requiredInput"
                className="ml-4 w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer"
                name="required"
                onChange={validation.handleChange}
                checked={validation.values.required || false}
              />
              {validation.touched.required && validation.errors.required ? (
                <p className="text-red-400">{validation.errors.required}</p>
              ) : null}
            </div>
            <div className="mb-3 flex">
              <label htmlFor="applyToAllInput" className="inline-block mb-2 text-base font-medium">Apply to All Services?</label>
              <input
                type="checkbox"
                id="applyToAllInput"
                className="ml-4 w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer"
                name="applyToAll"
                onChange={validation.handleChange}
                checked={validation.values.applyToAll || false}
              />
              {validation.touched.required && validation.errors.required ? (
                <p className="text-red-400">{validation.errors.required}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="serviceIdsInput" className="inline-block mb-2 text-base font-medium">Applied Services</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                id="serviceIdsInput"
                data-choices
                name="serviceIds"
                isMulti
                options={serviceDroplist}
                onChange={selectedOption => {
                  validation.setFieldValue(`serviceIds`, selectedOption?.map((item: any) => item.value))
                }}
                value={serviceDroplist.filter(service => { return validation.values.serviceIds.includes(service.value) })}
              />
              {validation.touched.serviceIds && validation.errors.serviceIds ? (
                <p className="text-red-400">{validation.errors.serviceIds}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="instructionInput" className="inline-block mb-2 text-base font-medium">Instruction</label>
              <input type="text" id="instructionInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Instruction"
                name="instruction"
                onChange={validation.handleChange}
                value={validation.values.instruction || ""}
              />
              {validation.touched.instruction && validation.errors.instruction ? (
                <p className="text-red-400">{validation.errors.instruction}</p>
              ) : null}
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={toggle}>Cancel</button>
              <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                {!!isEdit ? "Update Form" : "Add Form"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment >
  );
};

export default CustomForm;
